import LoginLoading from './LoginLoading.mapper';

export default LoginLoading;
